import camelCase from 'lodash/camelCase'

export function capitalize (s) {
  return s && s[0].toUpperCase() + s.slice(1)
}

export function camelize (s) {
  return s && camelCase(s)
}

export function fullCapitalize (s) {
  return s && capitalize(camelCase(s))
}

export function pemToSingleLineBase64 (pemString) {
  const lines = pemString.split('\n')
  lines.splice(0, 1)
  lines.splice(-2)
  const noHeaderOrFooter = lines.join('')
  return noHeaderOrFooter
}

export function hexStringToBuffer (hexString) {
  const intArray = parseHexString(hexString)
  const uint32Array = new Uint8Array(intArray)
  return uint32Array.buffer
  function parseHexString (str) {
    const result = []
    while (str.length >= 2) {
      result.push(parseInt(str.substring(0, 2), 16))
      str = str.substring(2, str.length)
    }
    return result
  }
}
